import { memo } from 'react';
import {
    lineHeightStyle,
    styledComponent,
    isExistAnyMentalStateExaminationData,
    defaultMentalStateData
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';

const MentalStateExaminationView = ({
    prescriptionItems,
    selectedOnExamination,
    setSelectedOnExamination,
    isHistoryPage,
}) => {
    let { mentalStateExamination } = selectedOnExamination;
    mentalStateExamination = mentalStateExamination || {};

    const removeItemsData = (fieldName) => {
        const resetFields = defaultMentalStateData();

        // Handle field reset
        if (fieldName in resetFields) {
            mentalStateExamination[fieldName] = resetFields[fieldName];
        }

        setSelectedOnExamination({
            ...selectedOnExamination,
            mentalStateExamination: { ...mentalStateExamination },
        });
    };

    const Title = styledComponent(
        prescriptionItems?.items?.['on-examination']?.itemStyle || {},
    );
    const Value = styledComponent(
        prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
    );

    return (
        <>
            {isExistAnyMentalStateExaminationData(mentalStateExamination) && (
                <>
                    <div className="mentalState-sub-title">Mental State Examination</div>
                    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
                        {mentalStateExamination.appearanceAndBehavior && (
                            <li className="text-left">
                                <Title>Appearance and Behavior:</Title>{' '}
                                <Value>{mentalStateExamination.appearanceAndBehavior}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="appearanceAndBehavior"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.speech && (
                            <li className="text-left">
                                <Title>Speech:</Title>{' '}
                                <Value>{mentalStateExamination.speech}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="speech"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.moodAndAffect && (
                            <li className="text-left">
                                <Title>Mood and Affect:</Title>{' '}
                                <Value>{mentalStateExamination.moodAndAffect}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="moodAndAffect"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.perception && (
                            <li className="text-left">
                                <Title>Perception:</Title>{' '}
                                <Value>{mentalStateExamination.perception}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="perception"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.thoughtProcess && (
                            <li className="text-left">
                                <Title>Thought Process:</Title>{' '}
                                <Value>{mentalStateExamination.thoughtProcess}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="thoughtProcess"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.thoughtContent && (
                            <li className="text-left">
                                <Title>Thought Content:</Title>{' '}
                                <Value>{mentalStateExamination.thoughtContent}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="thoughtContent"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.insight && (
                            <li className="text-left">
                                <Title>Insight:</Title>{' '}
                                <Value>{mentalStateExamination.insight}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="insight"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.judgment && (
                            <li className="text-left">
                                <Title>Judgment:</Title>{' '}
                                <Value>{mentalStateExamination.judgment}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="judgment"
                                    />
                                )}
                            </li>
                        )}

                        {mentalStateExamination.cognition && (
                            <li className="text-left">
                                <Title>Cognition:</Title>{' '}
                                <Value>{mentalStateExamination.cognition}</Value>
                                {!isHistoryPage && (
                                    <CommonDeleteBtn
                                        action={removeItemsData}
                                        itemName="cognition"
                                    />
                                )}
                            </li>
                        )}
                    </ul>
                </>
            )}
        </>
    );
};

export default memo(MentalStateExaminationView);